// extracted by mini-css-extract-plugin
export default {"container":"loader_container__ohCxL","loader":"loader_loader__3lTeP"};